import React, { useEffect, useState } from "react";

import ReactMarkdown from "react-markdown";
import { v4 as uuidv4 } from 'uuid';

import MqttClient from "lib/mqtt-client";
import { getAircareData } from "utils";
import ReportLoading from "components/report/ReportLoading";
import BasicSelect from "components/report/BasicSelect";

const TOPIC_AIRCARE_SUMMARY = "homey/aircare/summary";
const TOPIC_AI_OUTPUT = "ai/aircare/summary";

const PageReport = ({ userInfo }) => {
  const [mqttClient, setMqttClient] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [tone, setTone] = useState("normal");
  const [sessionId, setSessionId] = useState(uuidv4());

  const fetchReport = async () => {
    setReportData(null);
    if (userInfo?.remoteUrl) {
      setIsGenerating(true);
      const { summary } = await getAircareData(userInfo.remoteUrl);
      if (summary) {
        const message = {"session_id": sessionId, tone: tone, summary};
        mqttClient.sendMessage(TOPIC_AIRCARE_SUMMARY, JSON.stringify(message));
      }
    }
  };

  const handleMessage = (topic, message) => {
    console.log("handleMessage:", topic);
    if (topic === TOPIC_AI_OUTPUT) {
      const data = JSON.parse(message);
      if (sessionId !== data.session_id) {
        return;
      }
      setReportData({ content: data.response.error ?? data.response });
    }
    setIsGenerating(false);
  };

  useEffect(() => {
    const MQTT_BROKER = "ws://211.61.18.17:9001";
    const client = new MqttClient(MQTT_BROKER);
    setMqttClient(client);
    client.onMessage(handleMessage);
    client.connect(TOPIC_AI_OUTPUT);

    return () => client.disconnect();
  }, []);

  useEffect(() => {
    if (!userInfo) {
      setReportData(null);
    }
  }, [userInfo]);

  useEffect(() => {
    let timer;
    if (isGenerating) {
      timer = setTimeout(() => {
        setReportData({ content: "LLM Server time out!!" });
        setIsGenerating(false);
      }, 30 * 1000);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [isGenerating]);

  return (
    <div
      style={{
        background: "#fff",
        padding: "2rem",
        borderRadius: "1.5rem",
        boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
        border: "1px solid #e9e8ef",
        flex: 1,
        overflowY: "auto",
        position: "relative",
      }}
    >
      {isGenerating && <ReportLoading />}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1.5rem",
        }}
      >
        <h2 style={{ fontSize: "2rem", fontWeight: "bold", color: "#0f172a" }}>
          에어케어 리포트
        </h2>
        <div style={{ display: "flex" }}>
          <button
            onClick={fetchReport}
            style={{
              backgroundColor: "#7242EA",
              color: "#fff",
              padding: "0.6rem 1.2rem",
              borderRadius: "0.5rem",
              border: "none",
              fontWeight: "bold",
              cursor: "pointer",
              margin: "0.5rem",
            }}
          >
            Report
          </button>
          <BasicSelect tone={tone} setTone={setTone} />
        </div>
      </div>
      {reportData ? (
        <div
          style={{
            whiteSpace: "pre-wrap",
            lineHeight: "1.6",
            color: "#1e293b",
            fontSize: "1.5rem"
          }}
        >
          {reportData.content.split("\n\n").map((paragraph, idx) => (
            <ReactMarkdown key={idx}>{paragraph}</ReactMarkdown>
          ))}
        </div>
      ) : (
        <p style={{ color: "#64748b", fontStyle: "italic" }}>
          "Report" 버튼을 눌러 데이터를 불러오세요.
        </p>
      )}
    </div>
  );
};

export default PageReport;
